export default __webpack_public_path__ + "static/media/CollectiveMemory.d3e5dcc4.pdf";